export var HarmonyErrors;
(function (HarmonyErrors) {
    /**
     * Thrown when the response to get the UserInfo object returns with an empty
     * body.
     */
    HarmonyErrors["USER_INFO_REQUEST_EMPTY_RESPONSE"] = "USER_INFO_REQUEST_EMPTY_RESPONSE";
    /**
     * Thrown when the request to get the UserInfo object returns with a
     * non-successful status code.
     */
    HarmonyErrors["USER_INFO_REQUEST_FAILED_WITH_STATUS"] = "USER_INFO_REQUEST_FAILED_WITH_STATUS";
    // Harmony Errors
    /**
     * Thrown when trying to perform an operation when there is no playing track.
     */
    HarmonyErrors["HARMONY_NO_TRACKS_LOADED"] = "HARMONY_NO_TRACKS_LOADED";
    /**
     * Thrown when trying to perform an operation that is not allowed on the
     * current track or context.
     */
    HarmonyErrors["HARMONY_OPERATION_FORBIDDEN"] = "HARMONY_OPERATION_FORBIDDEN";
    /**
     * Thrown when trying to perform an operation while there is no local player.
     */
    HarmonyErrors["HARMONY_LOCAL_PLAYER_DISABLED"] = "HARMONY_LOCAL_PLAYER_DISABLED";
    /**
     * Thrown when the provided device descriptor id is not valid.
     */
    HarmonyErrors["HARMONY_INVALID_DESCRIPTOR_ID"] = "HARMONY_INVALID_DESCRIPTOR_ID";
    // Player API Client
    /**
     * Thrown when the arguments to a playback command operation are incorrect.
     */
    HarmonyErrors["CONNECTAPI_CLIENT_INVALID_ARGUMENTS"] = "CONNECTAPI_CLIENT_INVALID_ARGUMENTS";
    /**
     * Thrown when trying to register the Connect observer without a valid
     * connection id.
     */
    HarmonyErrors["CONNECTAPI_CLIENT_NO_CONNECTION_ID"] = "CONNECT_API_CLIENT_NO_CONNECTION_ID";
    /**
     * Thrown when trying to perform an operation targetting a device that is not
     * in the user's Connect Cluster.
     */
    HarmonyErrors["CONNECTAPI_CLIENT_NO_DEVICE"] = "CONNECTAPI_CLIENT_NO_DEVICE";
    /**
     * Thrown when trying to update the current context state that is not valid.
     */
    HarmonyErrors["CONNECTAPI_CLIENT_NO_SESSION_ID"] = "CONNECTAPI_CLIENT_NO_SESSION_ID";
    /**
     * Thrown when trying to update the current state when there is no current
     * state.
     */
    HarmonyErrors["CONNECTAPI_CLIENT_NO_STATE"] = "CONNECTAPI_CLIENT_NO_STATE";
    /**
     * Thrown when trying to seek to an invalid position.
     */
    HarmonyErrors["CONNECTAPI_CLIENT_INVALID_POSITION"] = "CONNECT_API_CLIENT_INVALID_POSITION";
    /**
     * Thrown when trying to set an invalid volume.
     */
    HarmonyErrors["CONNECTAPI_CLIENT_INVALID_VOLUME"] = "CONNECT_API_CLIENT_INVALID_VOLUME";
    /**
     * Thrown when the user has reached the maximum amount of registered Connect
     * clients.
     */
    HarmonyErrors["CONNECTAPI_MAX_SUBSCRIPTIONS_REACHED"] = "CONNECTAPI_MAX_SUBSCRIPTIONS_REACHED";
    /**
     * Thrown when the request to register the observer device fails with an
     * unsuccessful status code.
     */
    HarmonyErrors["CONNECTAPI_REGISTRATION_FAILED_WITH_STATUS"] = "CONNECTAPI_REGISTRATION_FAILED_WITH_STATUS";
    // PlayerQueue Errors
    /**
     * Thrown when trying to perform an operation without an active state.
     */
    HarmonyErrors["QUEUE_MANAGER_NO_STATE"] = "QUEUE_MANAGER_NO_STATE";
    /**
     * Thrown when trying to perform an operation with a stale revision.
     */
    HarmonyErrors["QUEUE_OPERATION_STALE_REVISION"] = "QUEUE_OPERATION_STALE_REVISION";
    // TPAPI Client response errors.
    /**
     * Thrown when the response to the Track Playback register request returns
     * with an empty body.
     */
    HarmonyErrors["TP_NO_RESPONSE_BODY"] = "TP_NO_RESPONSE_BODY";
    /**
     * Thrown when logging in a non-premium user on a device or application that
     * only supports premium.
     */
    HarmonyErrors["TP_REGISTRATION_FAILED_NON_PREMIUM"] = "TP_REGISTRATION_FAILED_NON_PREMIUM";
    /**
     * Thrown when the request to register the player fails with a non-successful
     * status code.
     */
    HarmonyErrors["TP_REGISTRATION_FAILED_WITH_STATUS"] = "TP_REGISTRATION_FAILED_WITH_STATUS";
    /**
     * Thrown when the user has reached the maximum amount of registered Connect
     * clients.
     */
    HarmonyErrors["TP_MAX_SUBSCRIPTIONS_REACHED"] = "TP_MAX_SUBSCRIPTIONS_REACHED";
    /**
     * Thrown when the request to Track Playback to update the current state
     * returns with an empty response.
     */
    HarmonyErrors["TP_UPDATE_REQUEST_EMPTY_RESPONSE"] = "TP_UPDATE_REQUEST_EMPTY_RESPONSE";
    /**
     * Thrown when the request to Track Playback to update the current state
     * results in a respones with a non-successful status code.
     */
    HarmonyErrors["TP_PARSE_STATE_UPDATE_FAILED_WITH_STATUS"] = "TP_PARSE_STATE_UPDATE_FAILED_WITH_STATUS";
    // TPAPI Client Command errors.
    /**
     * Thrown when an unknown command is received from the Track Playback service.
     */
    HarmonyErrors["TP_UNKNOWN_COMMAND"] = "TP_UNKNOWN_COMMAND";
    // TPAPI Client State errors
    /**
     * Thrown when the local player fails to create a State Reference that is
     * needed to send an update to Track Playback.
     */
    HarmonyErrors["TP_CANNOT_CREATE_STATE_REF"] = "TP_CANNOT_CREATE_STATE_REF";
    /**
     * Thrown when the initial state of a StateMachine from Track Playback is
     * missing.
     */
    HarmonyErrors["TP_MISSING_INITIAL_STATE"] = "TP_MISSING_INITIAL_STATE";
    /**
     * Thrown when a StateReference from a Track Playback operation resolves to a
     * non-existent state.
     */
    HarmonyErrors["TP_INVALID_STATE_REFERENCE"] = "TP_INVALID_STATE_REFERENCE";
    /**
     * Thrown when the request to Track Playback to resolve a conflict fails with
     * a non-successful status code.
     */
    HarmonyErrors["TP_CONFLICT_REQUEST_FAILED_WITH_STATUS"] = "TP_CONFLICT_REQUEST_FAILED_WITH_STATUS";
})(HarmonyErrors || (HarmonyErrors = {}));
//# sourceMappingURL=errors.js.map